/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import parseHtml from 'html-react-parser';

import TrackedLink from '../TrackedLink';
import defaultImage from '../../img/home_hero_image.jpg';

const Hero = ({
  plp: {
    plp: {
      actionUrl = '',
      backgroundImage = null,
      channelurl = '',
      customContactNumber = '',
      heroparagraph = '',
      leadHeroTitle = '',
    },
  },
}) => {
  const signUpUrl = (action = '', channel = '') => {
    if (action) {
      return action;
    }

    let urlPath = '/account/SignUp';
    let newChannel = channel;

    if (channel.indexOf('/app') === 0) {
      newChannel = channel.substring(4);
    }
    if (newChannel && newChannel.length > 0) {
      urlPath += `?returnUrl=${encodeURIComponent(newChannel)}`;
    }
    return urlPath;
  };

  return (
    <section
      className="hero-panel-home"
      style={{
        backgroundImage: `url(${
          backgroundImage ? backgroundImage.sourceUrl : defaultImage
        })`,
      }}
    >
      <div className="container">
        <div className="hero-text clearfix">
          <div className=" hero-intro">
            <h1 className="drk-bg">
              {leadHeroTitle || (
                <span style={{ display: 'inline-block', maxWidth: '400px' }}>
                  Where Small Businesses Get Funded
                </span>
              )}
            </h1>
          </div>
        </div>
        <div className="container subhero-contain">
          <div className="subhero flex">
            {heroparagraph ? (
              parseHtml(heroparagraph)
            ) : (
              <p>
                Get quick access to working capital with a line of credit*
                through Kabbage Funding™
              </p>
            )}
          </div>
        </div>
        <div className="two-column flex">
          <div className="column apply">
            <TrackedLink
              href={signUpUrl(actionUrl, channelurl)}
              className="pill-button large app-link apply-button"
            >
              Apply Now
            </TrackedLink>
          </div>
          <div className="column questions">
            <span>QUESTIONS?</span>{' '}
            <a
              className="number"
              href={`tel:${customContactNumber || '888-986-8263'}`}
            >
              {customContactNumber || '888-986-8263'}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

Hero.propTypes = {
  plp: PropTypes.shape({
    plp: PropTypes.shape({
      actionUrl: PropTypes.string,
      backgroundImage: PropTypes.shape({
        sourceUrl: PropTypes.string,
      }),
      channelurl: PropTypes.string,
      customContactNumber: PropTypes.string,
      heroparagraph: PropTypes.string,
      leadHeroTitle: PropTypes.string,
    }),
  }),
};

export default Hero;
